import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { getAllActivitiesForAccount } from "@/utils/supabase-queries";
import supabaseClient from "@/utils/supabase-browser";
import { UnwrapPromise } from "@/types";
import { AccountByIdData } from "../accounts";
import { isDemoAccount } from "@/utils/demo-helpers";
import { generateDemoActivities } from "@/utils/demo-data";
export type ActivitiesByIdData = UnwrapPromise<ReturnType<typeof useGetAllActivitiesForAccount>>;
export const useGetAllActivitiesForAccount = (accountId, page, initialData) => {
  const $ = _c(8);
  const t0 = page ?? 0;
  let t1;
  if ($[0] !== accountId || $[1] !== t0) {
    t1 = ["activities", accountId, t0];
    $[0] = accountId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== accountId || $[4] !== page) {
    t2 = async () => {
      if (isDemoAccount(accountId)) {
        return generateDemoActivities(accountId, 20);
      }
      return getAllActivitiesForAccount(supabaseClient, accountId, page);
    };
    $[3] = accountId;
    $[4] = page;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = !!accountId;
  let t4;
  if ($[6] !== t3) {
    t4 = {
      staleTime: 300000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      enabled: t3
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return useQuery(t1, t2, t4);
};